import UserSearchInput from './UserSearchInput';

export default UserSearchInput;
export type { UserSearchInputProps } from './UserSearchInput';
